export const API_URI = process.env.NODE_ENV === 'production' ? '' : 'https://gruppe-adler.de';
export const API_URL = `${API_URI}/api/v1`;
